import clamp from "lodash/clamp";
import drop from "lodash/drop";
import take from "lodash/take";
import { useCallback, useEffect, useState } from "react";
import { ObjectIndex } from "types";
import Pagination, { calculatePages } from "../pagination/pagination";
import Table, { TableProps } from "../table/table";

type DataTableProps<T> = TableProps<T>;

const paginate = (registries: any[], currentPage: number, itemsPerPage: number) => {
	const n = (currentPage - 1) * itemsPerPage;
	return take(drop(registries, n), itemsPerPage);
};

const DataTable = <T extends ObjectIndex>(props: DataTableProps<T>) => {
	const [currentPage, setCurrentPage] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const items = paginate(props.items, currentPage, itemsPerPage);

	const changePage = useCallback((page: number) => {
		const totalPages = calculatePages(props.items.length, itemsPerPage);
		setCurrentPage(clamp(page, 0, totalPages));
	}, [props.items, itemsPerPage]);

	const changeItemsPerPage = (value: number) => {
		setItemsPerPage(value);
	};

	useEffect(() => {
		changePage(1);
	}, [props.items, itemsPerPage, changePage]);

	return (
		<div className="row">
			<div className="col-sm-12">
				<Table {...props} items={items} />
				<Pagination
					currentPage={currentPage}
					itemsPerPage={itemsPerPage}
					numberOfRegistries={props.items.length}
					onPageChange={changePage}
					onItemsPerPageChange={changeItemsPerPage}
				/>
			</div>
		</div>
	);
};

export default DataTable;